// COMMENT IN FOR MORE LANGUAGE SUPPORT
// export const ENGLISH = 'en'
// export const RUSSIAN = 'ru'

export const ESTONIAN = 'et'
export const FALLBACK_LOCALE = ESTONIAN
export const SETTINGS_LOCALE_KEY = 'locale'
